module.exports = __webpack_public_path__ + "media/newstyle/images/nota-final2-b26bf402e6b8bfb42ac8e41aad74b143.png";